var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quesContainer"},[(_vm.answerData && _vm.answerData.intro)?[(
      _vm.formatHtml(
        _vm.answerData,
        _vm.answerData.intro,
        'intro',
        _vm.answerData.qtypename
      ).includes('$')
    )?_c('math-formula',{attrs:{"content":_vm.formatHtml(
      _vm.answerData,
      _vm.answerData.intro,
      'intro',
      _vm.answerData.qtypename
    )}}):_c('div',{staticClass:"quesContent",domProps:{"innerHTML":_vm._s(_vm.formatHtml(
      _vm.answerData,
      _vm.answerData.intro,
      'intro',
      _vm.answerData.qtypename
    )
      )}})]:_vm._e(),(_vm.answerData && _vm.answerData.question)?[(
      _vm.formatHtml(
        _vm.answerData,
        _vm.answerData.question,
        'question',
        _vm.answerData.qtypename
      ).includes('$')
    )?_c('math-formula',{attrs:{"content":_vm.formatHtml(
      _vm.answerData,
      _vm.answerData.question,
      'question',
      _vm.answerData.qtypename
    )}}):_c('div',{staticClass:"quesContent",domProps:{"innerHTML":_vm._s(_vm.formatHtml(
      _vm.answerData,
      _vm.answerData.question,
      'question',
      _vm.answerData.qtypename
    )
      )}})]:_vm._e(),(_vm.answerData && _vm.answerData.options && !['判断题', '填空题'].includes(_vm.answerData.qtypename))?[(
      _vm.formatHtml(_vm.answerData, _vm.answerData.options, 'options', _vm.answerData.qtypename).includes('$'))?_c('math-formula',{attrs:{"content":_vm.formatHtml(_vm.answerData, _vm.answerData.options, 'options', _vm.answerData.qtypename)}}):_c('div',{staticClass:"quesContent",domProps:{"innerHTML":_vm._s(_vm.formatHtml(_vm.answerData, _vm.answerData.options, 'options', _vm.answerData.qtypename)
      )}})]:_vm._e(),(_vm.answerData && _vm.answerData.dispAnswer)?[_c('div',{staticClass:"pt20 pb10 colorBlue b"},[_vm._v("[正确答案]")]),(
      _vm.formatHtml(
        _vm.answerData,
        _vm.answerData.dispAnswer,
        'dispAnswer',
        _vm.answerData.qtypename
      ).includes('$')
    )?_c('math-formula',{attrs:{"content":_vm.formatHtml(
      _vm.answerData,
      _vm.answerData.dispAnswer,
      'dispAnswer',
      _vm.answerData.qtypename
    )}}):_c('div',{staticClass:"quesContent",domProps:{"innerHTML":_vm._s(_vm.formatHtml(
      _vm.answerData,
      _vm.answerData.dispAnswer,
      'dispAnswer',
      _vm.answerData.qtypename
    ))}})]:_vm._e(),(_vm.answerData && _vm.answerData.analyse)?[_c('div',{staticClass:"pt20 pb10 colorBlue b"},[_vm._v("[答案解析]")]),(
      _vm.formatHtml(
        _vm.answerData,
        _vm.answerData.analyse,
        'analyse',
        _vm.answerData.qtypename
      ).includes('$')
    )?_c('math-formula',{attrs:{"content":_vm.formatHtml(
      _vm.answerData,
      _vm.answerData.analyse,
      'analyse',
      _vm.answerData.qtypename
    )}}):_c('div',{staticClass:"quesContent",domProps:{"innerHTML":_vm._s(_vm.formatHtml(
      _vm.answerData,
      _vm.answerData.analyse,
      'analyse',
      _vm.answerData.qtypename
    ))}})]:_vm._e(),(_vm.answerData && _vm.answerData.childQuestions && _vm.answerData.childQuestions.length > 0)?_vm._l((_vm.answerData.childQuestions),function(item2,index2){return _c('div',{key:item2.questionId},[(
        _vm.formatHtml(item2, item2.question, 'question1', item2.qtypename).includes('$'))?_c('math-formula',{attrs:{"content":_vm.formatHtml(item2, item2.question, 'question1', item2.qtypename)}}):_c('div',{staticClass:"quesContent",domProps:{"innerHTML":_vm._s(_vm.formatHtml(item2, item2.question, 'question1', item2.qtypename))}}),(item2.options && !['判断题', '填空题'].includes(item2.qtypename))?[(
          _vm.formatHtml(item2, item2.options, 'options', item2.qtypename).includes('$'))?_c('math-formula',{attrs:{"content":_vm.formatHtml(item2, item2.options, 'options', item2.qtypename)}}):_c('div',{staticClass:"quesContent",domProps:{"innerHTML":_vm._s(_vm.formatHtml(item2, item2.options, 'options', item2.qtypename))}})]:_vm._e(),(item2.dispAnswer || item2.answer)?[_c('div',{staticClass:"pt20 pb10 colorBlue b"},[_vm._v("[正确答案]")]),(
          _vm.formatHtml(item2, item2.dispAnswer || item2.answer, 'dispAnswer', item2.qtypename).includes('$'))?_c('math-formula',{attrs:{"content":_vm.formatHtml(item2, item2.dispAnswer || item2.answer, 'dispAnswer', item2.qtypename)}}):_c('div',{staticClass:"quesContent",domProps:{"innerHTML":_vm._s(_vm.formatHtml(item2, item2.dispAnswer || item2.answer, 'dispAnswer', item2.qtypename))}})]:_vm._e(),(item2.analyse)?[_c('div',{staticClass:"pt20 pb10 colorBlue b"},[_vm._v("[答案解析]")]),(
          _vm.formatHtml(item2, item2.analyse, 'analyse', item2.qtypename).includes('$'))?_c('math-formula',{attrs:{"content":_vm.formatHtml(item2, item2.analyse, 'analyse', item2.qtypename)}}):_vm._e(),_c('div',{staticClass:"quesContent",domProps:{"innerHTML":_vm._s(_vm.formatHtml(item2, item2.analyse, 'analyse', item2.qtypename))}})]:_vm._e()],2)}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }